export default __webpack_public_path__ + "static/cvc-432d6403a85c47a9b23cbb0504142d50.png";